import React from 'react'
import FileDropzone from './FileDropzone'
import axiosService from '../../utils/AxiosService'
import { Plus, Image } from 'react-bootstrap-icons'

export default function DraftUploader({ isCompact, url, onDocumentUpload = () => { }, onDocumentUploadFailure = () => { }, acceptedFileTypes, hintText }) {

  const uploadDraft = upload_files => {
    // Create and send a separate request for each file
    const uploadPromises = upload_files.map(file => {
      const draftData = new FormData()
      draftData.append('draft[upload_file]', file)
      
      return axiosService.post(url, draftData, { 
        headers: { "Content-type": "multipart/form-data" } 
      })
    })

    // Wait for all uploads to complete before calling onDocumentUpload
    Promise.all(uploadPromises)
      .then(responses => onDocumentUpload(responses))
      .catch(onDocumentUploadFailure)
  }

  return (
    isCompact ? (
      <FileDropzone uploadFiles={uploadDraft} icon={<Plus />} borderColor='border-rb-green' backgroundColor='bg-rb-soft-green' iconColor='#2CCDB4' isCompact={isCompact} maxFiles={0} acceptedFileTypes={acceptedFileTypes} hintText={hintText}/>
    ) : (
      <div className='h-[120px]'>
        <FileDropzone uploadFiles={uploadDraft} icon={<Image />} maxFiles={0} acceptedFileTypes={acceptedFileTypes} hintText={hintText}/>
      </div>
    )
  )
}
